export const setLanguage = payload => ({
  type: "SET_LANGUAGE",
  payload
});

export const setIndex= payload=>({
  type: "SET_INDEX",
  payload
})
